// src/components/notes/NoteComposer.jsx
import React, { useEffect, useRef, useState } from 'react';
import '../../styles/CommentSidebar.css';

export default function NoteComposer({
  onAdd,
  onBeginQuotePicking,          // () => void
  onRegisterQuoteAppend,        // (fn) => void (fn receives {text,page,rects})
}) {
  const [quote, setQuote] = useState('');
  const [text, setText] = useState('');
  const [page, setPage] = useState(null);
  const [rects, setRects] = useState(null);
  const [showForm, setShowForm] = useState(false);

  // Register paste handler so BookReader can pipe selection into this composer
  useEffect(() => {
    if (!onRegisterQuoteAppend) return;
    const append = ({ text: t, page: p, rects: r }) => {
      setQuote((prev) => (prev ? `${prev}\n${t}` : t));
      setPage(p || null);
      setRects(Array.isArray(r) && r.length ? r : null);
    };
    onRegisterQuoteAppend(append);
  }, [onRegisterQuoteAppend]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    onAdd({ quote: quote || '', text: text.trim(), page, rects });
    setQuote('');
    setText('');
    setPage(null);
    setRects(null);
    setShowForm(false);
  };

  return (
    <div className="comment-composer">
      {showForm ? (
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'flex', gap: 8, marginBottom: 6 }}>
            <button type="button" className="comment-book-btn" onClick={onBeginQuotePicking}>
              Highlight from page
            </button>
          </div>
          <label>
            Quoted Passage (optional):
            <textarea
              value={quote}
              onChange={(e) => setQuote(e.target.value)}
              placeholder="Highlight from the book..."
            />
          </label>
          <label>
            Your Note:
            <textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Write your personal note..."
              required
            />
          </label>
          <div className="composer-actions">
            <button type="submit">Save Note</button>
            <button type="button" onClick={() => setShowForm(false)}>Cancel</button>
          </div>
        </form>
      ) : (
        <button className="comment-book-btn" onClick={() => setShowForm(true)}>
          Add Note
        </button>
      )}
    </div>
  );
}
